import React from 'react';

import { useConversionTable } from 'hooks';
import { useCXI } from 'modules/cxi/useCXI';

import { Option } from '../components/option/Option';

import * as Form from '../components/form';

export const Stages = () => {
    const { t, vars, addVars } = useCXI();
    const conv = useConversionTable(['stages']);
    const data = vars.profile.profile.stages;

    const handleChange = value => {
        let newData = [...data];
        if (data.includes(value)) {
            newData = data.filter(v => v !== value);
        } else {
            newData.push(value);
        }

        const profile = {
            ...vars.profile,
            profile: {
                ...vars.profile.profile,
                stages: [...newData],
            },
        };
        addVars({ profile });
    };

    return (
        <Form.Form name="Stages">
            <Form.Title>{t('setup.Titles.stages')}</Form.Title>

            <Form.OptionsContainer>
                {Object.keys(conv.stages)
                    .map(value => parseInt(value, 10))
                    .map(value => (
                        <Option
                            label={conv.stages[String(value)]}
                            value={value}
                            key={value}
                            checked={!!data.includes(value)}
                            onChange={() => handleChange(value)}
                        />
                    ))}
            </Form.OptionsContainer>
        </Form.Form>
    );
};
